import { getCostCenterAccountData } from '@api/cost-centers';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export const useCostCenterAccount = () => {
  const { costCenterId } = useParams<{ costCenterId: string }>();

  const { data, isLoading } = useQuery({
    queryKey: ['cost-center-account-data', costCenterId],
    queryFn: () => getCostCenterAccountData(costCenterId!),
    enabled: !!costCenterId,
  });

  return {
    costCenterId,
    isLoading,
    data,
  };
};
